// Global Instructions Rule Applied!
//
// After a Configuration-screen cfg write (e.g. pipeline age thresholds), reload
// the backend global-configs cache and pull it into Redux so dependent screens
// (the deal board's age-threshold colours) update without a backend restart.
import { store } from '../../../state_manager/store.ts'
import { refreshGlobalConfigsThunk } from '../../global_configs/controller.ts'

export function refreshBoardConfigs(): void {
  const user = store.getState().auth.user
  if (user?.id && user?.email) {
    ;(store.dispatch as (action: unknown) => unknown)(refreshGlobalConfigsThunk({ id: user.id, email: user.email }))
  }
}
